// extracted by mini-css-extract-plugin
module.exports = {"Description":"LandingPage_Description__2MbQ3","container":"LandingPage_container__1G3pY","fastRegister":"LandingPage_fastRegister__L8and"};